import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#overview" }),
  /*#__PURE__*/_createTextVNode(" Overview ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Swap Font Awesome for modern ")
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  href: "https://icons8.com/line-awesome",
  class: "fw-bold",
  target: "_blank"
}, "Line Awesome Icons", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" in one line of code and use with ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" right away. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode("b", null, _toDisplayString(_ctx.themeName), 1),
      _hoisted_7
    ])
  ]))
}